import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import { Stage, ColormakerRegistry } from 'ngl/dist/ngl';

function StrViewNGL(props) {

    const [stage, setStage] = useState(null);

    const [controller, setController] = useState(null);

    const [pdbRepr, setPdbRepr] = useState(null);
    const [domainRepr, setDomainRepr] = useState(null);
    const [residueRepr, setResidueRepr] = useState(null);
    const [surfaceRepr, setSurfaceRepr] = useState(null);

    const { pdbId, domainId, domainInfo, selectedResidues, onLoadStructure, funsiteResidueSets } = props

    // funsiteResidueSets = [
    //     {
    //         id: 'biolip_lig', 
    //         label: 'BioLiP (ligand)',
    //         color: 'red',
    //         residues: ['23', '34']
    //     }
    // ]

    const rootDiv = React.useRef();

    // console.log("StrViewNGL: ", selectedResidues)

    let domainSelection = '';
    if (domainInfo) {
        domainSelection = domainInfo.segments.map((seg) => {
            return `${seg.pdb_start}-${seg.pdb_end}:${seg.chain_id}`;
        }).join(' or ')
    }

    let residueSelection = ''
    if (selectedResidues) {
        // console.log("selectedResidues: ", selectedResidues)
        residueSelection = selectedResidues.map((res) => {
            // console.log("selectedResidues.residue: ", res)
            if (res.resinsert) {
                return `${res.pdblabel}^${res.resinsert}:${res.chainid}`
            } else {
                return `${res.reslabel}:${res.chainid}`
            }
        }).join(' or ');
        // console.log("residueSelection: ", residueSelection)
    }

    useEffect(() => {
        console.log('StrViewNGL.setStage', stage, typeof stage, !stage);
        const rootElement = rootDiv.current;
        if (!stage) {
            // console.log("stage = null")
            const stg = new Stage(rootElement, { backgroundColor: 'white' });
            // console.log("setting stage...", stg, stage)
            setStage(stg);
            // console.log("set stage...", stg, stage)
        }
        console.log('StrViewNGL.setView', stage, pdbId);
        if (stage && pdbId) {
            // console.log('loading pdb: ', pdbId, stage);
            stage.loadFile("rcsb://" + pdbId + '.mmtf').then((o) => {
                // console.log('loading pdb: DONE');
                const pdbRepr = o.addRepresentation("cartoon", {
                    color: "white",
                    opacity: 0.2,
                });

                // console.log('applying domain selection: ', domainSelection);
                const domainRepr = o.addRepresentation("cartoon", {
                    color: "grey",
                    sele: domainSelection,
                    opacity: 1.0,
                });

                // console.log('applying residue selection: ', residueSelection);
                const resRepr = o.addRepresentation("ball+stick", {
                    color: "yellow",
                    sele: residueSelection ? residueSelection : '',
                    visible: residueSelection ? true : false,
                });

                // console.log('applying surface...');
                const surfaceRepr = o.addRepresentation("surface", {
                    surfaceType: "sas",
                    color: "white",
                    opacity: 0.1,
                    useWorker: true,
                    visible: false,
                });
                o.autoView();
                o.autoView(domainSelection, 1000);
                setController(o);
                setPdbRepr(pdbRepr);
                setDomainRepr(domainRepr);
                setResidueRepr(resRepr);
                setSurfaceRepr(surfaceRepr);
                onLoadStructure(o);
                // console.log('finished post PDB load...');
            });
        }
        // console.log('StrViewNGL.setView DONE');
    }, [pdbId, stage, domainSelection]);

    useEffect(() => {
        // console.log("StrViewNGL.selectedResidues: ", selectedResidues)
        if (residueRepr) {
            setResidueRepr(null);
            residueRepr.dispose();
        }
        // console.log('selected residues', selectedResidues, residueRepr);
        // console.log('controller', controller);
        if (!controller) return;
        if (!residueSelection) return;
        const newResidueRepr = controller.addRepresentation("ball+stick", {
            sele: residueSelection,
            scale: 3,
            color: "yellow",
        });
        setResidueRepr(newResidueRepr);

    }, [selectedResidues]);

    useEffect(() => {
        let scheme = []
        // console.log("NGL.funsiteResidueSets", funsiteResidueSets)
        if (funsiteResidueSets && domainRepr) {
            for (const resSet of funsiteResidueSets) {
                const selection = resSet.residues.join(" or ")
                // console.log("selection: ", resSet, selection)
                scheme.push([resSet.color, selection])
            }
            scheme.push(["grey", "*"])
            // console.log("NGL.funsiteResidueSets.scheme", scheme)
            const funsiteSchemeId = ColormakerRegistry.addSelectionScheme(scheme, 'Funsite')
            domainRepr.setColor(funsiteSchemeId)
        }
    }, [funsiteResidueSets]);

    return (
        <div style={{ 'height': 400 }} ref={rootDiv}></div>
    );
}

StrViewNGL.propTypes = {
    pdbid: PropTypes.string,
    funsiteResidueSets: PropTypes.array,
};


export default StrViewNGL;